import { useChecklistProgressStore, useChecklistStore } from "../store";
import { GeneralInfosStep, QuestionStep, SummaryStep } from ".";
import { ChecklistSignature } from "./checklist-signature";

export const ChecklistSteps = () => {
	const { answerData } = useChecklistStore((state) => state.checklist) || {};
	const currentStep = useChecklistProgressStore((state) => state.currentStep);
	const isLastStep = useChecklistProgressStore((state) => state.isLastStep);

	if (currentStep === 0 && answerData?.initializeMode === "NotSelected") {
		return <SummaryStep />;
	}
	if (currentStep === 1) {
		return <GeneralInfosStep />;
	}
	if (
		currentStep <= 2 ||
		(answerData?.checklistAnswer?.sections &&
			answerData?.checklistAnswer?.sections?.length + 1 >= currentStep)
	) {
		return <QuestionStep />;
	}
	if (isLastStep()) {
		return <ChecklistSignature />;
	}
};
